/**
 * Created by wuhuping on 2017/6/5.
 */
import * as types from '../mutation-types'
import router from '../../router'

// initial state
const state = {
  showTabbar: true,
  showHeader: true,
  ischecked: true
}
// getters
const getters = {}

// actions
const actions = {
  switchTabbarShow: function (context, show) {
    context.commit(types.SHOW_TABBAR, show)
  },
  switchHeaderShow: function (context, show) {
    context.commit(types.SHOW_HEADER, show)
  },
  switchCheckedShow: function (context, show) {
    context.commit(types.IS_CHECKED, show)
  }
}

// mutations
const mutations = {
  [types.SHOW_TABBAR](state, show) {
    state.showTabbar = show
  },
  [types.SHOW_HEADER](state, show) {
    state.showHeader = show
  },
  [types.IS_CHECKED](state, show) {
    state.ischecked = show
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js